export default __webpack_public_path__ + "media/images/wt-facebook-s-f1a52a9f.png";